import { DeploymentRequestDetailPageState } from ".";
import { generalCodeInitialState } from "../interface-definitions";

export const displayColumn = [
  { label: "Interrupt Type Pending", value: "interruptType" },
];

export const DeploymentRequestDetailPageInitialState: DeploymentRequestDetailPageState =
  {
    deploymentRequestDetail: {
      dplymntReqSeq: "",
      reverttargetdplymntReqSeq: "",
      jediPjtId: "",
      jediPjtName: "",
      jediPjtDescription: "",
      dplymntSts: "",
      dplymntStsTypeName: "",
      dplymntResultKbn: "",
      dplymntResultKbnName: "",
      dplymntType: "",
      dplymntTypeName: "",
      dplymntEnv: "",
      envId: "",
      reqUser: "",
      reqDtime: "",
      scheDtime: "",
      dplymntAprvr: "",
      aprvrDtime: "",
      rvwCmnt: "",
      retryCnt: 0,
      errorInfo: "",
      dplymntCmpDtime: "",
      updateDtimeTDplymntReqMng: "",
    },
    formValidation: {
      rvwCmnt: true,
    },
    ifList: [],
    tckIdList: [],
    deploySchedule: {
      type: "02",
      date: "",
      hour: "0",
      minutes: "0",
    },
    generalCode: generalCodeInitialState,
    edhNotificationType: {},
    displayColumn: displayColumn,
    fieldPath: { reviewComment: "reviewComment" },
    authorized: false,
  };
